import { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import Select from "react-select";
import { IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box} from '@mui/material';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import CloseIcon from "@mui/icons-material/Close";
import { getProductScoreWithNa } from "../../../utils/analysisTable/analysisUtils";

const orderOptions = [{ value: "asc", label: "Ascending" },{ value: "desc", label: "Descending" }];
// const baseVariableOptions = [{ value: "ascending", label: "ascending" },{ value: "descending", label: "descending" }];

function ProductSorting({ productsSecondaryData = [], dataMapping = [], analysisLevelData, settings, handleProductSorting = () => {} }) {
    const { box, key1, key2, key3, moduleName, noOfProducts } = analysisLevelData;
    const { isITMDataShown } = settings;
    const [open, setOpen] = useState(false);
    const [savedSelections, setSavedSelections] = useState({});
    const [baseVariableOptions, setBaseVariableOptions] = useState([]);

    useEffect(() => {
        if (productsSecondaryData.length && dataMapping.length) {
            let tempOptions = [];
            dataMapping.map((catObj) => {
                const { productScoreWithNaObj } = getProductScoreWithNa({ catObj, box, key1, key2, key3, isITMDataShown, moduleName, productsSecondaryData, noOfProducts });
                const kpis = catObj?.displayLabels || [];
                const uniqueKpis = new Set();
                kpis.map((bvObj) => {
                    const rowDisplayLabel = bvObj.displayLabel;
                    const rowBackendVariable = bvObj.backendVariable;
                    if (!uniqueKpis.has(bvObj.displayLabel)) {
                        const productsScoreWithNA = productScoreWithNaObj[rowDisplayLabel];
                        const rowBackendVariableDisplayLabel = bvObj.displayLabel.charAt(0).toUpperCase() + bvObj.displayLabel.slice(1);
                        uniqueKpis.add(bvObj.displayLabel);
                        if (!productsScoreWithNA || productsScoreWithNA < noOfProducts) {
                            const obj = {value: rowBackendVariable, label: rowBackendVariableDisplayLabel};
                            tempOptions.push(obj)
                        }
                    }
                })
                
            })
            setBaseVariableOptions(tempOptions)
        }
    },[productsSecondaryData, dataMapping, open])

    const handleSectionChange = (value, type) => {
        let obj = {...savedSelections};
        obj[type] = value.value;
        setSavedSelections(obj);
    }

    const handleSave = () => {
        // setSavedSelections({ option1, option2 });
        handleProductSorting(savedSelections.baseVariable, savedSelections.order);
        setOpen(false);
    };

    return (
        <span style={{ display: 'inline-flex', flexDirection: 'column', gap: '16px', alignItems: 'flex-start' }}>
            <Tooltip title="Product Sorting">
                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{
                        position: "relative",
                        right: 4,
                        top: 3,
                        color: key1 && key2 ? "rgb(169, 169, 169) !important" : "rgb(51, 94, 234) !important",
                    }}
                    disabled={key1 && key2}
                >
                    <ImportExportIcon />
                </IconButton>
            </Tooltip>

            <Dialog 
                open={open} 
                onClose={() => setOpen(false)} 
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                >
                    Product Sorting
                    <IconButton
                        aria-label="close"
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 5,
                            color: "rgb(51, 94, 234) !important",
                        }}
                        size="small"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{ fontSize: 12 }}>
                    <span style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                        <div 
                            className="dialogue-input-label-container"
                            style={{
                                width:"100%"
                            }}
                        >
                            <Select
                                className="dialogue-dropdown"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }),option: (base) => ({ ...base, fontSize: '12px' }), }}
                                // value={savedSelections.baseVariable}
                                value={baseVariableOptions.filter(
                                    (ele) => ele.value === savedSelections.baseVariable)
                                }
                                placeholder={"Select the base variable"}
                                options={baseVariableOptions}
                                onChange={(e) => handleSectionChange(e, "baseVariable")}
                            />
                        </div>

                        <div 
                            className="dialogue-input-label-container"
                            style={{
                                width:"100%"
                            }}
                        >
                            <Select
                                className="dialogue-dropdown"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }),option: (base) => ({ ...base, fontSize: '12px' }), }}
                                // value={savedSelections.order}
                                value={orderOptions.filter(
                                    (ele) => ele.value === savedSelections.order)
                                }
                                placeholder={"Sort by Order"}
                                options={orderOptions}
                                onChange={(e) => handleSectionChange(e, "order")}
                            />
                        </div>
                    </span>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Box
                        className=""
                        sx={{ width: "100%", textAlign: "center", paddingBottom: "5px" }}
                    >
                        <Button
                            variant="outlined" 
                            onClick={handleSave} 
                            disabled={!savedSelections.baseVariable || !savedSelections.order}
                        >
                            Get Result
                        </Button>
                    </Box>
                    
                </DialogActions>
            </Dialog>
        </span>
    );
}

ProductSorting.propTypes = {
    productsSecondaryData: PropTypes.array,
    dataMapping: PropTypes.array,
    analysisLevelData: PropTypes.object,
    settings: PropTypes.object,
    handleProductSorting:  PropTypes.func
};

export default ProductSorting;
